import { FallbackProps } from "react-error-boundary";

export type ErrorFallbackProps = FallbackProps;

export const ErrorFallback = ({ error, resetErrorBoundary }: ErrorFallbackProps) => (
  <div role="alert">
    <p>Error Message</p>
    <pre>{error instanceof Error ? error.message : String(error)}</pre>
    <button onClick={resetErrorBoundary}>Try again</button>
  </div>
);
